export default __webpack_public_path__ + "static/media/pdf-file.7fd8c8d0.svg";